/**
 * UpdateBanner - Shows when a new version of the app is available.
 * 
 * Fixed bar at the top of the screen with a "Reload Now" button.
 * Uses the useVersionCheck hook to detect new deployments via /version.json.
 */
import React from 'react';

export default function UpdateBanner({ onReload }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#0d6efd',
      color: '#fff',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      fontSize: '14px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <span>A new version of Archon is available.</span>
      <button
        onClick={onReload}
        style={{
          background: '#fff',
          color: '#0d6efd',
          border: 'none',
          borderRadius: '4px',
          padding: '5px 16px',
          fontWeight: 600,
          cursor: 'pointer',
          fontSize: '13px',
        }}
      >
        Reload Now
      </button>
    </div>
  );
}
